import en from './en';
import tr from './tr';

export default {
	tr: { translation: tr },
	en: { translation: en },
} as const;
